import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';
import { Link, useNavigate , useParams} from 'react-router-dom';
// import env from 'react-dotenv'

const PaymentPricingUpdate = () => {
    const [pricingType, setPricingType] = useState('one-time'); 
    const [commodity, setCommodity] = useState('');
    const [currency, setCurrency] = useState('');
    const [price, setPrice] = useState(0);
    const [subscriptionType, setSubscriptionType] = useState('');
    const [subscriptionReports, setSubscriptionReports] = useState(["Daily Price Report"]);
    const [reportType, setReportType] = useState('');
    const navigate = useNavigate()
    let {id} = useParams()

    const fetchHandler = async() =>{
        const response = await fetch(`${process.env.REACT_APP_API_URL}/prices/${id}`)
        const data = await response.json()
        if(data.pricingType === "one-time"){
            setPricingType("one-time")
            setCommodity(data.commodity)
            setCurrency(data.currency)
            setPrice(data.price)
            setReportType(data.reportType)
        } else if(data.pricingType === "subscription") {
            setPricingType("subscription")
            setCommodity(data.commodity)
            setCurrency(data.currency)
            setPrice(data.price)
            setSubscriptionType(data.subscriptionType)
            setSubscriptionReports(data.subscriptionReports)

        }
       // console.log(data)
    }
    useEffect(()=>{
        fetchHandler()
    },[])
    
    const handleAddReport = () => {
        setSubscriptionReports([...subscriptionReports, ""]);
      };
    
      const handleRemoveReport = (index) => {
        if (subscriptionReports.length > 1) { // Prevent removing last report
          const updatedReports = [...subscriptionReports];
          updatedReports.splice(index, 1);
          setSubscriptionReports(updatedReports);
        }
      };
    
      const handleInputChange = (event, index) => {
        const updatedReports = [...subscriptionReports];
        updatedReports[index] = event.target.value;
        setSubscriptionReports(updatedReports);
      };
    


    const handlePricingTypeChange = (e) => {
        setPricingType(e.target.value); 
    };

    

    const handleSubmit = async(e) =>{
        e.preventDefault();
        const obj = {
            pricingType: pricingType,
            commodity: commodity,
            currency: currency,
            price: price,
        }

        if(pricingType === "one-time"){
            obj.reportType = reportType

        } else if(pricingType === "subscription"){
            obj.subscriptionReports = subscriptionReports
            obj.subscriptionType = subscriptionType
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/prices/${id}`, {
            method: 'PUT',
            headers: {
              "Content-Type" : "application/json",
            },
            body: JSON.stringify(obj)
          })
          if(response.status  === 200){
            navigate(`/payment-pricing-table`)
          } else if(response.status !== 200){
            const errorMessage = await response.json()
            alert(errorMessage.message)
          }
    }

    return (
       <>
        <div className="sidebar">
      <Sidebar/>
      </div>

        <form onSubmit={handleSubmit} id='tabler'>
        <h1>Pricing Form</h1>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="radio"
                    name="pricingType"
                    id="one-time"
                    value="one-time"
                    checked={pricingType === 'one-time'}
                    onChange={handlePricingTypeChange}
                />
                <label className="form-check-label" htmlFor="one-time">
                    One-time
                </label>
            </div>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="radio"
                    name="pricingType"
                    id="subscription"
                    value="subscription"
                    checked={pricingType === 'subscription'}
                    onChange={handlePricingTypeChange}
                />
                <label className="form-check-label" htmlFor="subscription">
                    Subscription
                </label>
            </div>
           
            <div className='col-md-6'>
            <div className='mb-3'>
        <label for="number" className="form-label">
            Commodity
        </label>
        <select class="form-select" value={commodity} aria-label="Default select example" onChange={(e)=>setCommodity(e.target.value)}>
            <option selected> Select Commodity</option>
            <option value="cotton">Cotton</option>
            <option value="sugar">Sugar</option>
            <option value="wheat">Wheat</option>
            <option value="maize">Maize</option>
            <option value="rice">Rice</option>
            <option value="pulses">Pulses</option>
            <option value="spices">Spices</option>
            <option value="edible-oils">Edible Oils</option>
            
</select>
      </div>
        </div>


        <div className='col-md-6'>
            <div className='mb-3'>
        <label for="number" className="form-label">
            Currency
        </label>
        <select class="form-select" aria-label="Default select example" value={currency} onChange={(e)=>setCurrency(e.target.value)}>
            <option selected> Select Currency</option>
            <option value="USD">USD</option>
            <option value="PKR">PKR</option>
            
</select>
      </div>
        </div>

        <div className='col-md-6'>
            <div className='mb-3'>
        <label for="number" className="form-label">
            Price
        </label>
        <input id="num-value" value={price} type="number" min={0} className="form-control" placeholder='Enter Price' onChange={(e)=>setPrice(e.target.value)}/>
      </div>
        </div>



       {(pricingType === "one-time") && <div className='col-md-6'>
            <div className='mb-3'>
        <label for="number" className="form-label">
            Report Type
        </label>
        <input id="num-value" value={reportType} type="text" className="form-control" placeholder='Enter Report Type'  onChange={(e)=>setReportType(e.target.value)}/>
      </div>
        </div>}


      {(pricingType ==="subscription") &&  <div className='col-md-6'>
            <div className='mb-3'>
        <label for="number" className="form-label">
            Subscription Type
        </label>
        <select class="form-select" value={subscriptionType} aria-label="Default select example" onChange={(e)=>setSubscriptionType(e.target.value)}>
            <option selected> Select Subscription Type</option>
            <option value="basic">Basic</option>
            <option value="professional">Professional</option>
            <option value="advanced">Advanced</option>
</select>
      </div>
        </div>}

       {(pricingType === "subscription") && <div className="col-md-6">
      <div className="mb-3">
        <label for="number" className="form-label">Subscription Reports</label>
        <div className="input-container">
          {subscriptionReports.map((report, index) => (
            <div key={index}>
              <input
                id={`num-value-${index + 1}`}
                type="text"
                className="form-control"
                value={report} // Set value from state
                onChange={(e) => handleInputChange(e, index)}
                aria-labelledby="number"
              />
              <button
                type="button"
                className="btn btn-danger btn-sm remove-btn"
                onClick={() => handleRemoveReport(index)}
              >
                <i className="fas fa-minus"></i> Remove
              </button>
            </div>
          ))}
          <button type="button" className="btn btn-primary btn-sm add-more-btn" onClick={handleAddReport}>
            <i className="fas fa-plus"></i> Add another report
          </button>
        </div>
      </div>
    </div>}
    <button type="submit" class="btn btn-secondary">Submit</button>
        </form>
       </>

    );
};

export default PaymentPricingUpdate;
